export default __webpack_public_path__ + "assets/images/a2bc8c6917e7ce4d4acb89b98a1af432.png";